export function HubService($http, apexApiUrl) {
    'ngInject';
    return {
        retrieveHubs: retrieveHubs,
        retrieveHub: retrieveHub,
        saveHub: saveHub,
        deleteHub: deleteHub
    };

    function retrieveHubs() {
        return $http({
            method: "GET",
            url: apexApiUrl + "hubs"
        })
            .then(function (response) {
                return response.data;
            });
    }

    function retrieveHub(hubID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "hubs/" + hubID
        })
            .then(function (response) {
                return response.data;
            });
    }

    function saveHub(hub) {
        if (!hub.IsNew) {
            return $http({
                method: "PUT",
                url: apexApiUrl + "hubs/" + hub.Id,
                data: JSON.stringify(hub),
                headers: { "Content-Type": "application/json" }
            })
                .then(function () {
                    return hub;
                });
        } else {
            return $http({
                method: "POST",
                url: apexApiUrl + "hubs",
                data: JSON.stringify(hub),
                headers: { "Content-Type": "application/json" }
            })
                .then(function (response) {
                    return response.data;
                });
        }
    }

    function deleteHub(hubID) {
        return $http({
            method: "DELETE",
            url: apexApiUrl + "hubs/" + hubID,
            headers: {
                "Content-Type": "application/json"
            },
            data: {}
        });
    }
}
